import { Component, OnInit, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { FormActionComponent } from '../../../forms/components/form-action/form-action.component';
import { StartLoopComponent } from '../start-loop/start-loop.component';
import { TaskGroupListActionComponent } from '../task-group-list-action/task-group-list-action.component';
import { ShouldEndShiftConstant } from './should-end-shift.constant';
import { NgxPermissionsService } from 'ngx-permissions';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { ToasterService } from '../../../../../core/services/toaster.service';
import { ShiftPatrolListComponent } from '../shift-patrol-list/shift-patrol-list.component';
import { ScheduleService } from '../../../../../state/modules/schedule/services/schedule.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'kt-should-end-shift',
  templateUrl: './should-end-shift.component.html',
  styleUrls: ['./should-end-shift.component.scss'],
})
export class ShouldEndShiftComponent extends ModalBaseClass implements OnInit {
  timesheetPendingTask = null;
  buttonConfig = BUTTON_CONFIG;
  formConstant = ShouldEndShiftConstant;
  shiftTimesheetInfo = null;
  timesheet = null;
  isUncsheduled = false;
  location = { latitude: CommonUtil.Latitude, logitude: CommonUtil.Longitude };
  activeForm = null;
  activeTaskGroup = null;
  commentFormGroup = new UntypedFormGroup({});
  formManagmentFeature = this.ngxPermssionService.getPermission(PERMISSIONV2.FORM_MANAGEMENT)
  // loopFeature = this.ngxPermssionService.getPermission(PERMISSIONV2.LOOP_PATROL)
  patrolFeature = this.ngxPermssionService.getPermission(PERMISSIONV2.LOOP_PATROL)
  taskFeature = this.ngxPermssionService.getPermission(PERMISSIONV2.LOCATION_AREA_TASK)
  loading = signal(false);
  subscriptions: Subscription[] = [];

  constructor(public activeModal: NgbActiveModal, private ngbModal: NgbModal, private scheduleStoreService: ScheduleStoreService, private timesheetStoreService: TimesheetStoreService, public ngxPermssionService: NgxPermissionsService, private toaster: ToasterService,    public scheduleService: ScheduleService,

  ) {
    super(ngbModal);
  }

  ngOnInit() {
    this.setLocation();
  }


  setLocation() {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      // if (result.state === 'granted') {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.logitude = position.coords.longitude;
      });
      // }
      // });
    }
  }

  taskGroupClickHandler(task) {
    if (this.loading()) {
      return;
    }
    this.activeTaskGroup = task;
    this.dispatchTaskGroupDetail();
  }

  // loopClickHandler(loop) {
  //   const compRef = this.openPopUp(StartLoopComponent, { shiftInfo: this.shiftTimesheetInfo, preselectLoopId: loop.loop_id }, { centered: true, size: 'lg', backdrop: 'static' });
  //   compRef.result.then(res => {
  //     this.activeModal.close({reload: true});
  //   });
  // }

  patrolClickHandler() {
    if (this.loading()) {
      return;
    }
    this.loading.set(true);

    this.subscriptions.push(this.scheduleService.getShiftPatrolDetail({ timesheet_id: this.timesheet.timesheet_id }).subscribe(data => {
      if (data.success && data && data.data && data.data.data.patrol_detail) {
        const compRef = this.openPopUp(ShiftPatrolListComponent, { shiftInfo: this.shiftTimesheetInfo, patrolDetail: data.data.data.patrol_detail, user_id: LocalStorageUtil.getUserId(), timesheet: this.timesheet }, { centered: true, size: 'lg', backdrop: 'static' });
        compRef.result.then((res) => {
          if (res && res.reload) {
            this.activeModal.close({ reload: true });
          }
        }).catch(() => {});
        this.loading.set(false);
      }
      this.loading.set(false);
    }
      , (error) => {
        this.loading.set(false);
      }
    ));
    // const compRef = this.openPopUp(ShiftPatrolListComponent, { shiftInfo: this.shiftTimeSheetDetails }, { centered: true, size: 'lg', backdrop: 'static' });
  }

  makeFormPayload(form, activeForm) {
    return {
      client_id: this.shiftTimesheetInfo.client.client_id,
      location_id: this.shiftTimesheetInfo.location.location_id,
      area_id: this.shiftTimesheetInfo.area.area_id,
      timezone_id: 1,
      is_unscheduled: this.isUncsheduled,
      timesheet_id: this.timesheet.timesheet_id,
      shift_form_id: activeForm.shift_form_id,
      location_form_id: activeForm.location_form_id,
      form_id: form.form_id,
      type: activeForm.location_form_id ? TimesheetType.LOCATION : TimesheetType.SHIFT,
      timesheet_log: {
        timesheet_log_name: form.form_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: false,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.logitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
      timesheet_form: {
        timesheet_form_fk_form_id: form.form_id,
        timesheet_form_fk_form_name: form.form_name,
        timesheet_form_details: form,
        timesheet_form_config: {},
      },
    };
  }
  formFillHandler(actualForm, data) {
    this.loading.set(false);
    if (data.success && data.data.data.form && data.data.data.form) {
      let form = null;
      form = data.data.data.form.form;
      const componetRef = this.openPopUp(FormActionComponent, { fromInput: true, formData: form, viewMode: actualForm || (!this.timesheet) || (!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable)) ? true : false }, { centered: true, size: 'lg', backdrop: 'static' });
      componetRef.result.then(res => {
        if (res && res.formFilled) {
          this.dispatchFillform(this.makeFormPayload(form, this.activeForm));
        }
      });
    }
  }


  formFilled(data) {
    if (data.success) {
      this.activeModal.close({ reload: true });
    }
  }

  fillFormHandler(form) {
    if (this.loading()) {
      return;
    }
    this.activeForm = form;
    this.dispatchFormDetail();
  }

  // submitClickHandler() {
  // const mandatoryFormExist = this.timesheetPendingTask.form_pending && this.timesheetPendingTask.form_pending.length > 0 ? this.timesheetPendingTask.form_pending.find(form => form.location_form_is_required) : null;
  // const formInvalid = this.commentFormGroup.invalid;
  // if (formInvalid || mandatoryFormExist) {
  //   if
  //   if (mandatoryFormExist) 
  //     this.toaster.errorShow('Please fill mandatory forms', '', { closeButton: true, timeOut: 3000 });


  //   return;
  // }

  submitClickHandler() {

    const mandatoryFormExist = this.timesheetPendingTask.form_pending && this.timesheetPendingTask.form_pending.length > 0 ? this.timesheetPendingTask.form_pending.find(form => form.location_form_is_required) : null;
    const formInvalid = this.commentFormGroup.invalid;
    if (mandatoryFormExist) {
      this.toaster.errorShow('Please click on the form, complete all required fields, and submit the form to continue.', 'Complete Required Form', { closeButton: true, timeOut: 3000 });
      return;
    }
    if (formInvalid) {
      setTimeout(() => {
        return this.commentFormGroup.markAllAsTouched();
      });
      return;
    }

    this.activeModal.close({ endShift: true, reasons: this.commentFormGroup.value });
  }

  getFormDetailPayload(actualform = null) {
    return {
      type: this.activeForm.shift_form_id ? TimesheetType.SHIFT : TimesheetType.TIMESHEET,
      shift_form_id: this.activeForm.shift_form_id,
      location_form_id: this.activeForm.location_form_id,
      form_id: this.activeForm.form_id,
      timesheet_log_id: actualform ? actualform.timesheet_log_id : 0,
    };
  }
  taskGroupFillHandler(data) {
    this.loading.set(false);
    // console.log(data);
    if (data.success && data.data.data.task_group && data.data.data.task_group) {
      const task = data.data.data.task_group;
      const componetRef = this.openPopUp(TaskGroupListActionComponent, { task, shiftTimesheetInfo: this.shiftTimesheetInfo, isUncsheduled: this.isUncsheduled, taskGroupListDetail: this.activeTaskGroup, timesheet: this.timesheet, viewMode: (!this.timesheet) || (!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable)) ? true : false }, { centered: true, size: 'lg', backdrop: 'static' });
      componetRef.result.then(res => {
        // if (res.reload) {
        this.activeModal.close({ reload: true });
        // }
      });
    }
  }

  getTaskGroupDetail(actualTask = null) {
    return {
      type: this.activeTaskGroup && this.activeTaskGroup.shift_task_group_id ? TimesheetType.SHIFT : TimesheetType.TIMESHEET,
      shift_task_group_id: this.activeTaskGroup ? this.activeTaskGroup.shift_task_group_id : 0,
      location_task_group_id: this.activeTaskGroup ? this.activeTaskGroup.location_task_group_id : 0,
      task_group_id: this.activeTaskGroup ? this.activeTaskGroup.task_group_id : 0,
      timesheet_log_id: actualTask ? actualTask.timesheet_log_id : 0,
      timesheet_task_group_id: this.activeTaskGroup && this.activeTaskGroup.actual_task_group_new && this.activeTaskGroup.actual_task_group_new.length ? this.activeTaskGroup.actual_task_group_new[0].timesheet_task_group_id : actualTask ? actualTask.timesheet_task_group_id : 0,
    };
  }

  dispatchTaskGroupDetail() {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_TASK_GROUP_DETAIL,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: this.getTaskGroupDetail(),
      callback: this.taskGroupFillHandler.bind(this),
    });
  }


  dispatchFormDetail(actualForm = null) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_FORM_DETAIL,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: this.getFormDetailPayload(actualForm),
      callback: this.formFillHandler.bind(this, actualForm),
    });
  }

  dispatchFillform(data) {
    this.timesheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.FORM,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.formFilled.bind(this),
    });
  }

}
